export const initAppsFlyer = (webAppId: string) => {
  if (window.AF) {
    return;
  }

  window.AppsFlyerSdkObject = 'AF';

  window.AF =
    window.AF ||
    function (...args: any[]) {
      window.AF.q = window.AF.q || ([] as any[]).push([Date.now(), ...args]);
    };

  window.AF.id = {
    pba: {
      webAppId,
    },
  };

  window.AF.plugins = {};

  const script = document.createElement('script');

  script.async = true;
  script.src = `https://websdk.appsflyer.com?st=pba&af_id=${webAppId}`;

  document.head.appendChild(script);
};
